import React from 'react'
import { CuiChip } from 'front-lib'

import './Chip.scss'

const Chip = props => {
  const { label, selected, disabled, onClick } = props

  return (
    <CuiChip selected={selected} disabled={disabled} onClick={onClick}>
      {label}
    </CuiChip>
  )
}

export default Chip
